import { render } from "./progress-bar.vue?vue&type=template&id=05f54eda&scoped=true"
import script from "./progress-bar.vue?vue&type=script&lang=js"
export * from "./progress-bar.vue?vue&type=script&lang=js"

import "./progress-bar.vue?vue&type=style&index=0&id=05f54eda&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f54eda"]])

export default __exports__